import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './MockPayment.css';

const MockPayment = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);

  const paymentId = searchParams.get('paymentId');
  const transactionId = searchParams.get('transactionId');

  const handleApprove = async () => {
    setProcessing(true);
    // Simulate payment processing delay
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Redirect to success page (simulating Nuapay callback)
    const callbackUrl = `${process.env.REACT_APP_API_URL}/api/guardian-pay/response/callback?paymentId=${paymentId}&status=SETTLEMENT_COMPLETE`;

    // Call the callback endpoint
    try {
      await fetch(callbackUrl, {
        method: 'GET',
      });
    } catch (error) {
      console.error('Error calling callback:', error);
    }

    // Redirect to guardian dashboard
    navigate('/guardian-dashboard?payment=success');
  };

  const handleDecline = async () => {
    setProcessing(true);
    // Simulate payment processing delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    // Redirect to failure page
    navigate('/guardian-dashboard?payment=failed');
  };

  return (
    <div className="mock-payment-container">
      <div className="mock-payment-card">
        <div className="mock-payment-header">
          <h2>🧪 Mock Payment Gateway</h2>
          <p className="mock-badge">DEVELOPMENT MODE</p>
        </div>

        <div className="mock-payment-body">
          <div className="payment-info">
            <h3>Payment Details</h3>
            <div className="info-row">
              <span className="label">Payment ID:</span>
              <span className="value">{paymentId}</span>
            </div>
            <div className="info-row">
              <span className="label">Transaction ID:</span>
              <span className="value">{transactionId}</span>
            </div>
          </div>

          <div className="mock-instructions">
            <p>
              <strong>Test the payment flow:</strong>
            </p>
            <ul>
              <li>Click <strong>"Approve Payment"</strong> to simulate successful payment</li>
              <li>Click <strong>"Decline Payment"</strong> to simulate failed payment</li>
            </ul>
          </div>

          <div className="mock-payment-actions">
            <button
              className="btn btn-success btn-lg"
              onClick={handleApprove}
              disabled={processing}
            >
              {processing ? 'Processing...' : '✓ Approve Payment'}
            </button>
            <button
              className="btn btn-danger btn-lg"
              onClick={handleDecline}
              disabled={processing}
            >
              {processing ? 'Processing...' : '✗ Decline Payment'}
            </button>
          </div>

          <div className="mock-note">
            <p>
              <strong>Note:</strong> This is a mock payment page for development testing only.
              Real Nuapay integration will be used in staging/production environments.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MockPayment;
